var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-demo-box',{attrs:{"demo-option":"audiencePropensities"}},[(_vm.isMobile)?[_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select',{attrs:{"needDemo":true}})],1)]:[_c('div',{staticClass:"mt-4"},[_c('m-demo-all-check')],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('m-demo-select-p-c',{attrs:{"needDemo":true}})],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a933aad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/DemoAudiencePropensities.vue
// module id = null
// module chunks = 